export const onboardingActions = Object.seal({
  openHelpMenu: () => {},
  closeHelpMenu: () => {},
});
